// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-group-wrapper[data-v-4dc824a2]{display:flex}.btn-group-wrapper .btn-group[data-v-4dc824a2]{margin:0 auto;background-color:#eaf1fc;border-radius:50px;overflow:hidden}.btn-group-wrapper .btn-group button[data-v-4dc824a2]{color:#2e76e4;border-radius:50px;border:none;padding:11px 30px;font-size:14px;font-weight:700}.btn-group-wrapper .btn-group button.selected[data-v-4dc824a2]{color:#fff;background-color:#2e76e4}", ""]);
// Exports
module.exports = exports;
